export const constant = {
  thHolidayHeading: 'Thomson Reuters Holidays',
  supportClosedText: 'Support is closed on the dates below',
  holidayText: 'Holiday',
  dateText: 'Date',
};
